import account from './account';
import assets from './assets';
import availability from './availability';
import booking from './booking';
import checkout from './checkout';
import entry from './entry';
import product from './product';
import property from './property';
import reservation from './reservation';
import resource from './resource';
import securePayment from './secure_payment';
import services from './services';
import utility from './utility';
import vehicleLink from './vehicle_link';

export default {
  assets,
  availability,
  booking,
  reservation,
  securePayment,
  checkout,
  account,
  vehicleLink,
  product,
  utility,
  resource,
  property,
  services,
  entry,
};
